export default [
  // 快捷同步链接兑换码
  {
    path: '/qsl/:code',
    name: 'QuickSyncLink',
    meta: { title: '涂层兑换码' },
    component: () => import('@/views/QuickSyncLink')
  }
]
